import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Link from 'components/common/Link';
import IconDownload from 'components/icons/IconDownload';

import formatPrice from 'utils/formatPrice';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  cellName: {
    textTransform: 'capitalize',
  },
  iconDownload: {
    display: 'inline-block',
    width: 16,
    height: 16,
    marginRight: 4,
    verticalAlign: 'middle',
  },
});

const PaymentEventsTableRow = ({ classes, ...otherProps }) => (
  <TableRow>
    <TableCell className={classes.cellName}>
      {otherProps['Stripe Event Type'] && otherProps['Stripe Event Type'].ID ? otherProps['Stripe Event Type'].Name : ''}
    </TableCell>
    <TableCell>
      {otherProps['Create At']}
    </TableCell>
    <TableCell>
      {otherProps.User && otherProps.User.ID ? `${otherProps.User['First Name']} ${otherProps.User['Last Name']}` : ''}
    </TableCell>
    <TableCell>
      {otherProps['Stripe Product'] && otherProps['Stripe Product'].ID ? otherProps['Stripe Product'].Name : ''}
    </TableCell>
    <TableCell>
      {otherProps['Stripe Price'] && otherProps['Stripe Price'].ID ? formatPrice(otherProps['Stripe Price']['Unit Amount']) : ''}
    </TableCell>
    <TableCell>
      {otherProps['Payment Amount'] ? formatPrice(otherProps['Payment Amount']) : ''}
    </TableCell>
    <TableCell>
      {otherProps['Payed From'] && otherProps['Payed To'] ? `${otherProps['Payed From']}-${otherProps['Payed To']}` : ''}
    </TableCell>
    <TableCell>
      {otherProps['Stripe Request'] && otherProps['Stripe Request'].data
        && otherProps['Stripe Request'].data.object && otherProps['Stripe Request'].data.object.failure_message
          ? otherProps['Stripe Request'].data.object.failure_message : ''}
      {otherProps['Stripe Request'] && otherProps['Stripe Request'].data
        && otherProps['Stripe Request'].data.object && otherProps['Stripe Request'].data.object.invoice
          ? otherProps['Stripe Request'].data.object.invoice : ''}
      {otherProps['Stripe Request'] && otherProps['Stripe Request'].data
        && otherProps['Stripe Request'].data.object && otherProps['Stripe Request'].data.object.invoice_pdf
          ? (<Link
              size="md"
              color="primary"
              target="_blank"
              download={otherProps['Stripe Request'].data.object.invoice_pdf}
              href={otherProps['Stripe Request'].data.object.invoice_pdf}
            > 
              <IconDownload className={classes.iconDownload} />
              {otherProps['Stripe Request'].data.object.id}
            </Link>)
          : ''}
    </TableCell>
  </TableRow>
);

PaymentEventsTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    cellName: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PaymentEventsTableRow);



// WEBPACK FOOTER //
// ./src/components/settings/PaymentEventsTable/PaymentEventsTableRow.js